var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgFeaturedCardBackground = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 2238,
    height: 1494,
    viewBox: "0 0 2238 1494",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_955",
    "data-name": "Rectangle 955",
    width: 2238,
    height: 1494,
    transform: "translate(-0.364)",
    fill: "#fff",
    stroke: "#707070",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_954",
    "data-name": "Rectangle 954",
    width: 3128.69,
    height: 1557.348,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-3"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_953",
    "data-name": "Rectangle 953",
    width: 5987.802,
    height: 9186.096,
    fill: "#d5d2d2"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_487",
    "data-name": "Path 487",
    d: "M8355.85,3343.721c-95.2-235.906,19.923-506.827,255.822-602.032S9118.5,2761.61,9213.7,2997.516,9193.764,3504.3,8957.866,3599.5a458.564,458.564,0,0,1-171.876,33.446c-183.251.018-357.632-109.57-430.141-289.23m25.027-1173.926c-550.466,222.158-819.118,854.275-596.961,1404.743s854.285,819.055,1404.755,596.9c550.425-222.134,821.946-847.1,596.915-1404.713l.01,0c-169.182-419.2-576.179-674.93-1003.731-674.949a1069.127,1069.127,0,0,0-400.987,78.028",
    transform: "translate(-7705.882 -2091.767)",
    fill: "rgba(144,130,222,0.89)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-5"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_488",
    "data-name": "Path 488",
    d: "M8245.685,2721.889c-226.476-108.111-331.854-389.769-223.765-616.288l-.008-.007c108.1-226.52,396.938-334.783,613.4-230.936,236.558,112.372,341.933,394.046,226.7,623.455-79.151,165.867-247.569,265.24-423.822,265.242a467.628,467.628,0,0,1-192.507-41.465M8032.261,1285.117l-12.114,4.891c-330.471,135.645-585.347,429.954-651.043,804.722-71.71,419.643,55.345,775.73,379.7,1043.837,341.538,269.518,718.164,317.031,1114.23,165.493v.007c546.208-212.131,829.252-334.664,1365.439-551.056,185.832-75,265.477-248.474,196.236-420.04-66.357-164.421-244.084-233.986-429.919-158.991L9530.13,2361.5c-3.045-48.679-.307-83.045-4.658-114.5-24.617-555.363-462.618-1002.076-1016.729-1036.172-24.836-1.679-49.671-2.508-74.27-2.51a1090.1,1090.1,0,0,0-402.212,76.8",
    transform: "translate(-7349.691 -1208.321)",
    fill: "rgba(144,130,222,0.89)"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_23",
    "data-name": "Mask Group 23",
    transform: "translate(0.365)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1469",
    "data-name": "Group 1469",
    transform: "translate(-873.053 -63.15)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_486",
    "data-name": "Path 486",
    d: "M0,0H3111.358V1557.345H0Z",
    transform: "translate(0.001 63.396)",
    fill: "#e0e2f4"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1468",
    "data-name": "Group 1468",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1467",
    "data-name": "Group 1467",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1466",
    "data-name": "Group 1466",
    transform: "translate(-385.233 -2259.705)",
    opacity: 0.248
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1465",
    "data-name": "Group 1465"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1464",
    "data-name": "Group 1464",
    clipPath: "url(#clip-path-3)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1461",
    "data-name": "Group 1461",
    transform: "translate(1217.908 2802.946)",
    opacity: 0.595
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1460",
    "data-name": "Group 1460",
    clipPath: "url(#clip-path-4)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_951",
    "data-name": "Rectangle 951",
    width: 3156.199,
    height: 3221.573,
    transform: "translate(-1067.489 1837.935) rotate(-63.325)",
    fill: "rgba(144,130,222,0.89)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1463",
    "data-name": "Group 1463",
    transform: "translate(334.609 612.13)",
    opacity: 0.595
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1462",
    "data-name": "Group 1462",
    clipPath: "url(#clip-path-5)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_952",
    "data-name": "Rectangle 952",
    width: 3443.12,
    height: 3865.206,
    transform: "translate(-953.784 1794.379) rotate(-63.325)",
    fill: "rgba(144,130,222,0.89)"
  }))))))))))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgFeaturedCardBackground);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/FeaturedCardBackground.40614f5df156ccaae2ba9e50af12a3a6.svg";